import BaseInfo from '@/model/modules/BaseInfo'

export default class UserGroupTokenInfo extends BaseInfo {
  groupId: number = 0
  companyId: number = 0
  appKey: string = ''
  appSecret: string = ''
  authorizedKey: string = ''
}
